import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { toast } from 'sonner';
import { courierKeys, mapCourierError, useTranslation } from '@dukanti/shared';
import { confirmCourierDeliveryProof } from '@dukanti/shared/services';
import type { AdminCourierProof, TranslationKey } from '@dukanti/shared';
import { supabase } from '@/lib/supabase';

export function useConfirmCourierDeliveryProof(
  storeId: string,
): UseMutationResult<AdminCourierProof, unknown, string> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<AdminCourierProof, unknown, string>({
    mutationFn: (proofId) => confirmCourierDeliveryProof(supabase, storeId, proofId),
    onSuccess: (proof) => {
      void queryClient.invalidateQueries({ queryKey: courierKeys.proof(storeId, proof.id) });
      void queryClient.invalidateQueries({ queryKey: courierKeys.batches(storeId) });
      void queryClient.invalidateQueries({ queryKey: ['store-orders', storeId] });
      void queryClient.invalidateQueries({ queryKey: ['admin-order-detail', proof.order_id] });
      toast.success(t('admin.orders.courierProof.confirmed' as TranslationKey));
    },
    onError: (err) => {
      toast.error(t(mapCourierError(err) as TranslationKey));
    },
  });
}
